import UltMeta, { Meta } from "./UltMeta";

/**
 * 开票状态
 */
class InvoiceStatus extends UltMeta {
    NOT_STARTED = new Meta(0, "未开票");
    IN_PROGRESS = new Meta(1, "开票中");
    COMPLETED = new Meta(2, "已开票");
}
export const INVOICE_STATUS = new InvoiceStatus();
